<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>

          <v-toolbar color="grey" dark>
            <v-toolbar-title>Usuarios
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <!-- <v-btn color="yellow  darken-2" icon>
              <v-icon>mdi-magnify</v-icon>
            </v-btn> -->
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="grey darken-2" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>

              <!--<v-btn slot:activator="{on}" color="grey darken-2" dark class="mb-2">Nuevo</v-btn>-->
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>

                </v-card-title>
                <v-card-text>

                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-select
                          :items="rolesList"
                          v-model="editedItem.role"
                          label="Role"
                          item-value="id"
                          item-text="name"
                          :rules="notBlankRules"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.name" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.adscripcion" label="Adscripción" :rules="notBlankRules"></v-text-field>
                        </v-flex xs12>
                        <v-flex xs12>
                          <v-select
                          v-if="editedItem.role > 3 || editedItem.role === ''"
                          :items="salasList"
                          v-model="editedItem.sala"
                          label="Sala"
                          item-value="id"
                          item-text="nombre"
                          :rules="notBlankRules"
                          ></v-select>
                          <!-- <v-text-field v-model.trim="editedItem.cargo" label="Cargo" :rules="notBlankRules">
                          </v-text-field> -->
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.email" label="Email" :rules="emailRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1 && currentUser.role_id == 1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox v-if="editedIndex > -1"
                            v-model="changePassword"
                            label="Cambiar Contraseña"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 v-if="editedIndex == -1 || changePassword">
                          <v-text-field v-model.trim="editedItem.password" label="Contraseña" :type="show ? 'text' : 'password'"
                                        :rules="notBlankRules"
                          >
                          </v-text-field>
                          <v-text-field v-model.trim="editedItem.password_confirmation" label="Confirmar Contraseña" :type="show ? 'text' : 'password'"
                                        :rules="notBlankRules"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" @click.native="editUser(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                          <v-btn v-else color="yellow darken-2" @click.native="addUser(editedItem)" :disabled="!valid" :loading="loading" class="white--text">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog><!-- end dialog edit o save-->
          </v-toolbar>
          <v-card-title>
            <v-row
              align="center"
              justify="space-around"
            >
              <v-col cols="4" class="mb-n6">
                <v-text-field
                  v-model="buscarNombre"
                  label="Nombre ó Email"
                  item-value="id"
                  item-text="giro"
                  outlined
                  clearable
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="4" class="mb-n6">
                <v-autocomplete
                  v-model="filtrarRol"
                  :items="listRolesActivas"
                  label="Rol"
                  item-value="id"
                  item-text="name"
                  outlined
                  clearable
                  dense
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="4" class="mb-n6">
                <v-select
                  label="Filtrar por Sala"
                  item-text="nombre"
                  item-value="id"
                  :items="salasList"
                  v-model="filtrarSala"
                  clearable
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-btn
                dark
                class="ma-2 mb-n4"
                color="#24406d"
                @click="getUsers()"
              >
                Buscar
              </v-btn>
            </v-row>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="listUsers"
            item-key="user"
            class="elevation-1"
            light
            actions
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
            :loading="loading"
          >
            <template v-slot:item.action="{ item }">
              <v-icon v-if="!item.deleted_at || currentUser.role_id == 1" color="orange" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon v-if="(currentUser.role_id == 2 || currentUser.role_id == 1) && !item.deleted_at" color="red"  @click="deleteUser(item)">mdi-close</v-icon>
              <!--<v-icon dark>mdi-folder-settings-variant</v-icon>-->
            </template>
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
              >mdi-check-bold</v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
              >mdi-minus</v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-3">
            <v-pagination
              v-if="listUsers.length > itemsPerPage"
              v-model="page"
              :length="pageCount"
              :total-visible="7"
              color="#AF8936"
              circle
            ></v-pagination>
          </div><br>
        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      buscarNombre: '',
      filtrarRol: '',
      filtrarSala: '',
      // search: '',
      changePassword:false,
      mask: '##########',
      celular: '',
      activo: true,
      valid: true,
      dialog: false,
      loading:false, //component
      show: false,
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      headers: [
        {
          text: 'Usuario',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Rol', value: 'rol.role_name', sortable: true },
        { text: 'Sala', value: 'sala', sortable: true },
        { text: 'Adscripción', value: 'adscripcion', sortable: true },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action' }
      ],
      listUsers: [],
      rolesList: [],
      salasList: [],
      distritosList:[],
      editedIndex: -1,
      editedItem: {
        role:'',
        name:'',
        sala:'',
        adscripcion:'',
        email:'',
        password: '',
        password_confirmation:'',
      },
      defaultItem: {
        role:'',
        name:'',
        sala:'',
        adscripcion:'',
        email:'',
        password: '',
        password_confirmation:'',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingrese un correo valido',
      ]
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters([
      "listRoles", //getters de roles.js
      "selectRoles",
      "listRolesActivas",
      "roleUser",
      "currentUser"
    ]),
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    },
  },
  mounted() {
    this.getUsers();
    this.getRoles();
    this.getSalas();
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    getUsers() {
      this.filtro = {
        full_name: this.buscarNombre || undefined,
        role_id: this.filtrarRol || undefined,
        sala_id: this.filtrarSala || undefined
      }
      this.$store
        .dispatch("GET_USERS",{
          data: this.filtro
        })
        .then((response) => {
          this.listUsers = response.data.users;//usar response para datos, se puede usar getters
          // console.log(response);
        })
        .catch(err => {
          console.log(err);
          //this.showAlert(this.notification);
        });
    },
    getRoles() {
      this.$store
        .dispatch("SELECT_ROLES")
        .then((response) => {
          this.rolesList = response.data;//usar response para datos, se puede usar getters
          //console.log(response);
        })
        .catch(err => {
          console.log(err);
          //this.showAlert(this.notification);
        });
    },
    getSalas() {
      this.$store
        .dispatch("GET_SALAS")
        .then((response) => {
          this.salasList = response.data.salas;//usar response para datos, se puede usar getters
          // console.log(response);
        })
        .catch(err => {
          console.log(err);
          //this.showAlert(this.notification);
        });
    },
    editItem (item) {
      this.editedIndex = this.listUsers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.sala = parseInt(item.sala)
      if (this.editedItem.deleted_at) this.activo = false
      else this.activo = true
      this.dialog = true
    },
    addUser(){
      if (this.$refs.form.validate()) {
        this.loading = true;
        var data = this.editedItem;
        this.$store
          .dispatch("SAVE_USERS",data)
          .then((response) => {
            console.log(response.message);
            this.close ();
            Swal.fire({
              icon: 'success',
              title: 'Se Guardo Correctamente',
              showConfirmButton: false,
              timer: 1500
            })
            this.getUsers();
            //this.roles = response.data;//usar response para datos, se puede usar getters
            //console.log(response);
          })
          .catch(error => {
            console.log(error);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response.data.status,
                showConfirmButton: false,
                timer: 1500
              })
            //this.showAlert(this.notification);
          });
        this.loading = false;
      }
    },
    editUser(item){
      if (this.$refs.form.validate()) {
        this.loading = true;
        item.activo = this.activo
        // console.log("store",item);
        //var data = this.$data;
        this.$store
          .dispatch("EDIT_USER",item)
          .then((response) => {
            this.dialog=false;
            Swal.fire({
              icon: 'success',
              title: 'Actualizado Correctamente',
              showConfirmButton: false,
              timer: 1500
            })
            this.getUsers();
            //this.roles = response.data;//usar response para datos, se puede usar getters
          })
          .catch(err => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: err.response.data.status,
              showConfirmButton: false,
              timer: 1500
            })
            //this.showAlert(this.notification);
          });
        this.loading = false;
      }
    },
    deleteUser(item){
      this.$swal({
        title: '¿Desea eliminar al usuario "' + item.name + '"?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("DELETE_USER",item.id)
            .then((response) => {
              Swal.fire({
                icon: 'success',
                title: 'Se Eliminó Correctamente',
                showConfirmButton: false,
                timer: 1500
              })
              this.getUsers();
            })
            .catch(err => {
              console.log(err);
              Swal.fire({
                icon: 'error',
                title: err.response.data.msg,
                confirmButtonText: "Aceptar"
              })
              //this.showAlert(this.notification);
            });
        }
      })
      // confirm('Seguro de eliminar el usuario?') &&
      //console.log("store",item.id);
      //var data = this.$data;
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
